<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('productGroupOrderManage.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="productGroupOrderManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input :placeholder="$t('productGroupOrderManage.orderIdPlaceholder')"
              v-model="productGroupOrderManageInfo.conditions.orderId" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input :placeholder="$t('productGroupOrderManage.productNamePlaceholder')"
              v-model="productGroupOrderManageInfo.conditions.prodName" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input :placeholder="$t('productGroupOrderManage.buyerPlaceholder')"
              v-model="productGroupOrderManageInfo.conditions.buyerName" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input :placeholder="$t('productGroupOrderManage.groupLeaderPlaceholder')"
              v-model="productGroupOrderManageInfo.conditions.groupBuyerName" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="productGroupOrderManageInfo.conditions.state"
              :placeholder="$t('productGroupOrderManage.statusPlaceholder')" style="width:100%">
              <el-option :label="$t('productGroupOrderManage.allStatus')" value=""></el-option>
              <el-option :label="$t('productGroupOrderManage.groupSuccess')" value="1001"></el-option>
              <el-option :label="$t('productGroupOrderManage.groupFail')" value="2002"></el-option>
              <el-option :label="$t('productGroupOrderManage.grouping')" value="3003"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryProductGroupOrderMethod()" icon="el-icon-search">
              {{ $t('productGroupOrderManage.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('productGroupOrderManage.groupOrder') }}</div>
      </div>
      <div class="">
        <product-group-order-table
          :productGroupOrders="productGroupOrderManageInfo.productGroupOrders"></product-group-order-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="productGroupOrderManageInfo.conditions.page"
          :page-size="productGroupOrderManageInfo.conditions.row" layout="total, prev, pager, next"
          :total="productGroupOrderManageInfo.total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { listProductGroupOrder } from '@/api/group/productGroupOrderApi'
import { getShopId } from '@/api/shop/shopApi'
import ProductGroupOrderTable from '@/components/group/productGroupOrderManage/productGroupOrderTable'

export default {
  name: 'ProductGroupOrderManage',
  components: {
    ProductGroupOrderTable
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      productGroupOrderManageInfo: {
        productGroupOrders: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          orderId: '',
          prodName: '',
          buyerName: '',
          groupBuyerName: '',
          state: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listProductGroupOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    async _listProductGroupOrders(_page, _rows) {
      this.productGroupOrderManageInfo.conditions.page = _page
      this.productGroupOrderManageInfo.conditions.row = _rows
      this.productGroupOrderManageInfo.conditions.shopId = getShopId()

      try {
        const res = await listProductGroupOrder(
          this.productGroupOrderManageInfo.conditions
        )
        this.productGroupOrderManageInfo.total = res.total
        this.productGroupOrderManageInfo.records = res.records
        this.productGroupOrderManageInfo.productGroupOrders = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _queryProductGroupOrderMethod() {
      this._listProductGroupOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleCurrentChange(val) {
      this._listProductGroupOrders(val, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
  padding: 15px 20px 20px 20px;
}
</style>